import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import { BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Row, Col, Navbar } from 'react-bootstrap';

import { Provider } from 'react-redux';
import store from './store.js';

import IndexApp from './components/IndexApp';
import Login from './components/Login';
import Register from './components/Register';
import ForgetPwd from './components/ForgetPwd';
import CustomerHeader from './components/CustomerHeader';
import CustomerHeaderFooter from './components/CustomerHeaderFooter';
import Header from './components/Header';
// import Footer from './components/Footer';

import AdsApp from './components/ads/AdsApp';
import AdsCreateApp from './components/ads/AdsCreateApp';
import AdsDetailApp from './components/ads/AdsDetailApp';
import AdsClickApp from './components/ads/AdsClickApp';

import MemberApp from './components/members/MemberApp';
import MemberDetailApp from './components/members/MemberDetailApp';
import MemberPointApp from './components/members/MemberPointApp';
import MemberRedeemApp from './components/members/MemberRedeemApp';

import ProjectsApp from './components/projects/ProjectsApp';
import ProjectsAddApp from './components/projects/ProjectsAddApp';
import ProjectsAddCustApp from './components/projects/ProjectsAddCustApp';
import ProjectsEditCustApp from './components/projects/ProjectsEditCustApp';
import ProjectsDetailApp from './components/projects/ProjectsDetailApp';
import ProjectsNewApp from './components/projects/ProjectsNewApp';
import ProjectsEditApp from './components/projects/ProjectsEditApp';

import ProjectsCustApp from './components/projects/ProjectsCustApp';

import GoodsCreateApp from './components/goods/GoodsCreateApp';
import GoodsApp from './components/goods/GoodsApp';
import GoodsDetailApp from './components/goods/GoodsDetailApp';
import GoodsRecordLotteryApp from './components/goods/GoodsRecordLotteryApp';
import GoodRecordRedeemApp from './components/goods/GoodsRecordRedeemApp';

import ChargeApp from './components/Charge/ChargeApp';
import ChargeDemoApp from './components/Charge/ChargeDemoApp';
import ChargeCalculatorApp from './components/Charge/ChargeCalculatorApp';

import QuestAdd from './components/projects/quests/QuestAddApp';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
//fontawesome
import '@fortawesome/fontawesome-free/css/all.min.css';
//for glyphicons
// import './css/glyphicon.css';
import './css/react-dropzone-style.scss'
import './css/bootstrap-theme.min.css';
import './css/style.scss';
import { Container } from 'react-bootstrap';
import TestMain from './components/test/TestMain.js';
import { hookstore } from './hookstore';
import { StoreContext } from 'redux-react-hook';
import API from './api';
import { CookiesProvider, withCookies } from 'react-cookie';


class errorUrl extends Component {
  render() {
    return (<div className="wrapper"><div className="errorUrl">404<br /><span>Page not found.</span></div></div>)
  }
}


class TmpRouter extends Component {
  render() {
    let isAdmin = API.getIsAdmin();
    console.log("index", window.location.hash, isAdmin);

    // if ("" == isAdmin || null == isAdmin) {
    let loginDom = (
      <Switch>
        <Row path={/^(.*(login|signup|forget)).*$/} className="loginBg">
          <Col>
            {/* <CustomerHeaderFooter className="pt-4" /> */}
            {/* <div className='mt-4'>aaaa</div> */}
            <Route path="/login" component={Login} />
            <Route path="/signup" component={Register} />
            <Route path="/forget" component={ForgetPwd} />
          </Col>
        </Row>
        <Route path="/login" component={Login} />
        {"" == isAdmin ? <Redirect to="/login" /> : <Redirect to="/index" />}
      </Switch>
    );

    let mainAPPDom = (
      <>
        <CustomerHeaderFooter />

        <Row className="mb-4">
          <Col xs={3}>
            <Route path={/^(?!.*(login|signup|forget)).*$/} component={CustomerHeader} />
          </Col>
          <Col xs={9} className="mt-5">
            {/* <IndexRoute component={IndexApp} /> */}
            {/* <Route path="^(?!(\/login)).*" component={Header}/> */}
            <Route path="/member/redeem/:id" component={MemberRedeemApp} />
            <Route path="/member/point/:id" component={MemberPointApp} />
            <Route path="/member/detail/:id" component={MemberDetailApp} />
            <Route path="/member/index" component={MemberApp} />
            <Route path="/proj/index" component={ProjectsCustApp} />
            <Route exact path="/charge/index/:oid/:status" component={ChargeApp} />
            <Route exact path="/charge/index/:oid" component={ChargeApp} />
            <Route exact path="/charge/index" component={ChargeApp} />
            <Route path="/charge/calculator" component={ChargeCalculatorApp} />
            <Route path="/charge/demo" component={ChargeDemoApp} />


            {/* <Route path="/proj/detail/:id" component={QuestAdd} /> */}
            {/* <Redirect from="/proj/edit/:id" to="/proj/aa/:id" /> */}
            <Route
              exact
              path="/proj/edit/:id"
              render={props => (
                <Redirect to={`/proj/edit/${props.match.params.id}/1`} />
              )}
            />
            <Route path="/proj/edit/:pid/:step" exact component={ProjectsEditCustApp} />
            <Route path="/proj/edit/:pid/:step/:oid" exact component={ProjectsEditCustApp} />
            <Route path="/proj/edit/:pid/:step/:oid/:status" exact component={ProjectsEditCustApp} />
            {/* <Route path="/proj/edit/:id" exact component={ProjectsEditCustApp} /> */}
            {/* <Route path="/proj/new" component={ProjectsNewApp} /> */}
            <Route path="/proj/add" component={ProjectsAddCustApp} />
            <Route path="/goods/detail/:id" component={GoodsDetailApp} />
            <Route path="/goods/record_lottery/:id" component={GoodsRecordLotteryApp} />
            <Route path="/goods/record_redeem/:id" component={GoodRecordRedeemApp} />
            <Route path="/goods/create" component={GoodsCreateApp} />
            <Route path="/goods/index" component={GoodsApp} />
            {/* <Route path="/send_notify" component={} />
                <Route path="/send_main" component={} /> */}
            <Route path="/ads/create" component={AdsCreateApp} />
            <Route path="/ads/detail/:id" component={AdsDetailApp} />
            <Route path="/ads/click/:id" component={AdsClickApp} />
            <Route path="/ads/" component={AdsApp} />
            {/* <Route path="/add_quest/:id" component={QuestAdd} /> */}
            <Route path="/test/:id" component={TestMain} />
            {/* <Route path={"/"} component={IndexApp} /> */}
            {/* <Route path={"/index"} component={IndexApp} /> */}
            {/* <Route exact path="/" component={IndexApp} />
              <Route path="/index" component={IndexApp} /> */}
            <Route path={/^((\/)|(\/index))$/} component={IndexApp} />
            {/* <Route path="/404" component={errorUrl} /> */}
            {/* <div>{isAdmin}</div> */}
            {/* {"" == isAdmin ? <Redirect to="/login" /> : <Redirect to="/index" />} */}
          </Col>
        </Row>
      </>
    );

    return (
      <>{
        <Switch>
          <Route path="/charge/demo" component={ChargeDemoApp}></Route>
          <Route path={/^(.*(login|signup|forget)).*$/}>{loginDom}</Route>
          <Route path={/^(?!.*(login|signup|forget)).*$/}>{mainAPPDom}</Route>
        </Switch>
      }
      </>
    );
  }
}

class TmpIndex extends Component {

  render() {
    let isAdmin = API.getIsAdmin();
    console.log("TmpIndex", window.location.hash, isAdmin);
    return (
      <CookiesProvider>
        <StoreContext.Provider value={hookstore}>
          <Provider store={store}>
            {/* <BrowserRouter> */}
            <HashRouter>
              {/* <Header /> */}
              <Container fluid={true}>
                <script src="https://unpkg.com/react/umd/react.production.js" crossOrigin="true" />
                <script
                  src="https://unpkg.com/react-dom/umd/react-dom.production.js"
                  crossOrigin="true"
                />
                <script
                  src="https://unpkg.com/react-bootstrap@next/dist/react-bootstrap.min.js"
                  crossOrigin="true"
                />
                <Switch>
                  <Route
                    path="/"
                    render={() => (<TmpRouter cookies={this.props.cookies} />)}
                  />

                </Switch>
              </Container>
              {/* </BrowserRouter> */}
            </HashRouter>
          </Provider>
        </StoreContext.Provider>
      </CookiesProvider>
      // </React.StrictMode>
    )
  }
}

ReactDOM.render(<TmpIndex />,
  document.getElementById('root')
)
